import Home from "../views/Home.vue";
import SelectTest from "../views/tests/SelectTest.vue";
import Induction from "../views/tests/Induction.vue";
import Tests from "../views/tests/Tests.vue";
import Test from "../views/tests/Test.vue";
import Results from "../views/tests/Results.vue";

const appRoutes = [
  {
    path: "/home",
    name: "Home",
    component: Home,
    meta: {
      requiresAuth: ["ADM", "SEC", "CON", "VIS", "EMP"],
      title: "Home",
      navbarTitle: "Home",
      navbarIcon: "mdi-home"
    }
  },
  {
    path: "/inductions",
    name: "SelectTest",
    component: SelectTest,
    meta: {
      navbarTitle: "Induction",
      navbarIcon: "mdi-play"
    },
    children: [
      {
        path: "",
        name: "SelectTest",
        component: Tests,
        props: { testId: "" },
        meta: {
          title: "Inductions",
          requiresAuth: ["ADM", "SEC", "CON", "VIS", "EMP"]
        }
      },
      {
        path: "induction/:testId",
        name: "Induction",
        component: Induction,
        props: { testId: "" },
        meta: {
          title: "Induction",
          requiresAuth: ["ADM", "SEC", "CON", "VIS", "EMP"]
        }
      },
      {
        path: "test/:testId",
        name: "Test",
        component: Test,
        props: { testId: "" },
        meta: {
          title: "Test",
          requiresAuth: ["ADM", "SEC", "CON", "VIS", "EMP"]
        }
      },
      {
        path: "results/:userTestId",
        name: "Results",
        component: Results,
        props: { userTestId: "" },
        meta: {
          title: "Results",
          requiresAuth: ["ADM", "SEC", "CON", "VIS", "EMP"]
        }
      }
    ]
  }
];

export default appRoutes;
